// Helpers de texto — contraparte programática de .aa-h-* / .aa-eyebrow / .aa-p-*.
// `split: true` marca el elemento con data-aa-split para el reveal de motion.ts.

export type HeadingSize = 'xxl' | 'xl' | 'l' | 'ml' | 'm';
export type ParagraphSize = 'l' | 'm';

interface HeadingOptions {
  size: HeadingSize;
  text: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4';
  split?: boolean;
  className?: string;
  highlight?: string; // substring envuelto en gradiente (no usa SplitText, rompe el clip)
}

interface ParagraphOptions {
  size: ParagraphSize;
  text: string;
  className?: string;
}

function cx(...parts: (string | false | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}

export function renderHeading(opts: HeadingOptions): HTMLElement {
  const { size, text, tag = 'h2', split, className, highlight } = opts;
  const el = document.createElement(tag);
  el.className = cx(`aa-h-${size}`, className);

  if (highlight && text.includes(highlight)) {
    const idx = text.indexOf(highlight);
    const before = text.slice(0, idx);
    const after = text.slice(idx + highlight.length);
    if (before) el.appendChild(document.createTextNode(before));
    const span = document.createElement('span');
    span.className = 'aa-text-gradient';
    span.textContent = highlight;
    el.appendChild(span);
    if (after) el.appendChild(document.createTextNode(after));
    el.setAttribute('data-aa-fade', ''); // reveal por fade (no split)
  } else {
    el.textContent = text;
    if (split) el.setAttribute('data-aa-split', '');
  }

  return el;
}

export function renderEyebrow(text: string, className?: string): HTMLElement {
  const el = document.createElement('span');
  el.className = cx('aa-eyebrow', className);
  el.textContent = text;
  return el;
}

export function renderParagraph(opts: ParagraphOptions): HTMLElement {
  const { size, text, className } = opts;
  const el = document.createElement('p');
  el.className = cx(`aa-p-${size}`, className);
  el.textContent = text;
  return el;
}
